
$(document).ready(async ()=>{
    // async function firstProduct(container){
        // const productId = $('#product-metacamp').data('product-id');
        // console.log('id do first product', productId);
        // const discount = await hasDiscount(productId);
        // console.log('discount dentro de firstproduct',discount)
        // return discount;
    // }

    //Função para observar mutações no DOM
    function observaMutation(elementToWatch, callback, passObserver = false, options = { add: false, remove: false, attributes: false, any: false}){
        const config = {
            childList: true, // Observa adição/remoção de nós filhos
            attributes: true, // Observa mudanças em atributos
            subtree: true // Observa todas as mudanças na subárvore do elemento
        };

        const callbackMutation = async function (mutationsList, observer) { // Adicionado async aqui
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    if (mutation.addedNodes.length > 0 && options.add) {
                        passObserver ? callback(observer) : callback();
                        passObserver ? observer.disconnect() : ''; //encontramos, podemos parar.
                    }
                }
                
                if (mutation.removedNodes.length > 0 && options.remove) {
                    passObserver ? callback(observer) : callback();
                    passObserver ? observer.disconnect() : ''; //encontramos, podemos parar.
                }
                if (mutation.type === "attributes"  && options.attributes) {
                    passObserver ? callback(observer) : callback();
                    passObserver ? observer.disconnect() : ''; //encontramos, podemos parar.
                }
                if(options.any){
                    passObserver ? callback(observer) : callback();
                    passObserver ? observer.disconnect() : ''; //encontramos, podemos parar.
                }   
            }
        };

        
        // Cria uma instância do MutationObserver com a função de callback
        const observer = new MutationObserver(callbackMutation);

        // Inicia a observação no elemento lista com as configurações definidas
        observer.observe(elementToWatch, config);
    }

    //Transformar em ùtil ou semelhante.
    //Função adaptada de mltivariant-prices
    //Tem como objetivo devolver o objeto desconto tal qual abaixo
    /*
    const discount = {
                    oldValue: Number,
                    newValue: Number,
                    difference: Number,
                    percentage: Number
                }
    */
    //Será aplicado o desconto diretamente no upsell por outra via, visto que já temos o container
    async function hasDiscount(productId){ 
        const utils = new Utils();
        await utils.delay(500);
        const ymqSpan = $(`[ymq-b2b-product-id='${productId}']`);
        if(ymqSpan.length > 0){
            const ymqMoneySpan = ymqSpan?.children('.ymq-b2b-price-span');

            const currency =  ymqMoneySpan.first().text().match(/[^\d.,]+/g)?.[0].trim() || '';
                                                                        //Tal qual em multivariants, deve ser alterado para a CURRENCY atualpara funcionamento internacional
            const ymqValue = Number(ymqMoneySpan?.first().text().replace(currency, "").replace(/\./g, "").replace(",", "."));

            if(ymqValue == 0){
            return null;
            }

            const compareElement = ymqSpan?.siblings('.ymq-b2b-cp-compare-price');
            if(compareElement.length > 0){
                const ymqOldValue = Number(compareElement.first().text().replace("R$", "").replace(/\./g, "").replace(",", "."));
                const discountPercentage = ymqValue / ymqOldValue;
            
                const discount = {
                    percentage: discountPercentage,
                    currency
                }
                return discount;
            }
            return { currency }
        }
        return null
    }

    //Função para pegar os containers de produtos do upsell
    //Deve retornar os containers de produtos do upsell
    //Ele pega o container contendo checkbox, preço e select (estes últimos em subcontainer separado do primeiro)
    //É uma função recursiva com limite de até 20 tentativas, caso não encontre o container
    //A cada tentativa, espera 800ms para tentar novamente (para sincronismo com os outros apps e scripts rodando na página)
    async function getContainers(counter = 0){
        const upsellApp = $('essential-upsell-frequently-bought-together-app-block');

        const contentContainers = upsellApp.find('[data-essential-upsell-element="products"] [data-essential-upsell-element="product"] [data-essential-upsell-element="content-container"]');
        const contents = contentContainers.find('[data-essential-upsell-element="content"]');

        const titleElements = contents.find('a');

        if(titleElements.length > 0 && titleElements.length == contents.length-1 || titleElements.length >= contents.length-1){
            return contentContainers;
        }

        counter++;

        if(counter > 20) {
            return contentContainers;
        }

        const utils = new Utils();
        await utils.delay(800);
        return getContainers(counter)    
    }

    //Função que busca encontrar o produto com handle igual ou semelhante com base numa porcentagem de letras encontradas e no tamanho do nome do produto
    async function matchAndGetProduct(productHandle, shopifyHandle){
        const productHandleUndashed = productHandle.replace(/-/g, ' ');
        const shopifyHandleUndashed = shopifyHandle.replace(/-/g, ' ');
        
        const shopifyLength = shopifyHandleUndashed.split(' ').length;      
        const handleArray = productHandleUndashed.split(' ');
        
        let  count = 0;
        for(const str of handleArray){
            if(shopifyHandleUndashed.includes(str)) count++;
        }

        const matchPercentage = (count / shopifyLength) * 100;

        if(shopifyLength <=3 ){
            const product = (matchPercentage >= 50) ? await getProduct(shopifyHandle) :  null;
            return product;
        }
        if(shopifyLength <=12 ){
            const product = (matchPercentage >= 72) ? await getProduct(shopifyHandle) :  null;
            return product;
        }
        
        const product = (matchPercentage >= 85) ? await getProduct(shopifyHandle) :  null;
        return product;
    }

    //Esconde o elemento dentro de upssel
    //Por default esconde claim price
    async function hidePrice(container, upsellElement = 'price', className = 'visibility-hidden'){
        if(!container) return; //Verificando se o elemento existe

        if (!container.find) { //verificando se é um elemento jQuery
            //Se não for, transformá-lo em e fazer
            $(container).find(`[data-essential-upsell-element="${upsellElement}"]`).addClass(className);
            return
        }
        //Se for jQuery, fazer
        container.find(`[data-essential-upsell-element="${upsellElement}"]`).addClass(className);
    }

    //Mostra o elemento dentro de upssel
    //Por default mostra claim price
    async function showPrice(container, upsellElement = 'price', className = 'visibility-hidden'){
        if(!container) return; //Verificando se o elemento existe
        
        if (!container.find) { //verificando se é um elemento jQuery
            //Se não for, transformá-lo em e fazer
            $(container).find(`[data-essential-upsell-element="${upsellElement}"]`).removeClass(className);
            return
        }
        //Se for jQuery, fazer
        container.find(`[data-essential-upsell-element="${upsellElement}"]`).removeClass(className);
    }

    //Lógica principal do script
    async function loadUpsellPrices(upsellApp, frequentlyBoughtProducts = null){
        // Configurações do MutationObserver (o que observar)
        observaMutation(upsellApp[0], async (observer = null) =>{
            const contentContainers = await getContainers();
            
            if (contentContainers.length > 0) {
                await hidePrice(upsellApp, 'discounted-price', 'hidden');
                await hidePrice(contentContainers);
                upsellApp.removeClass('hidden');

                if(observer) observer.disconnect();
                
                let forIndex = 0;
                const newUpsellPrices = [];
                let currency;
                
                //Para cada container/produto encontrado no upsell, incluindo o da própria página (o primeiro)
                for (const contentContainer of contentContainers) { 
                    // if(forIndex === 0){ //Por enquanto não é necessário uma lógica própria para o primeiro elemento
                    //     await firstProduct(contentContainer);
                    //     console.log('pulou', contentContainer);
                    //     forIndex++;
                    //     continue;
                    // }
                    
                    let productTitle = $(contentContainer).find('[data-essential-upsell-element="title"]').text();
                    if(productTitle === ''){
                        continue;
                    }
                    
                    const utils = new Utils();
                    const productHandle = utils.handleString(productTitle); //Transforma título do produto encontrado em handle

                    const upsellData = frequentlyBoughtProducts ? frequentlyBoughtProducts.find(obj => {
                        return obj.shopifyHandle === productHandle
                    }
                    ) : null;

                    //Cfazer verificação de texto com a url ou simplesmentenão exibir ou não o preço
                    //Primeiro tentamos utilizar o produto retornado pela api - se tivermos algum problema aqui, seja pelo handle incorreto ou não existir o produto, 
                    //utilizamos então o produt o registrado no próprio upsell, com base em matching do handle, para pegarmos da api
                    const productFromApi = upsellData ? await getProduct(upsellData.shopifyHandle) : await getProduct(productHandle);

                    let product = productFromApi;
                    if(!product){
                        product = await (async () => {
                            // Algum código adicional aqui, se necessário
                            let product;
                            for (const data of frequentlyBoughtProducts) {
                                product = await matchAndGetProduct(productHandle, data.shopifyHandle);
                                if (product) return product;
                            }
                            return null;
                        })();
                    }
                    
                    //Não mostrar preço se não houver preço correto.
                    if(!product){
                        await hidePrice(contentContainer);
                        continue;
                    }

                    //Também não exibir o preço quando não houver desconto.
                    const upsellYmqContainer = $('#upsell-ymq');
                    if( upsellYmqContainer.find(`[ymq-b2b-product-id="${product.id}"]`).length == 0){
                        const html = `
                            <div class='price__regular hidden'>
                                <span class='price-item price-item--regular'>
                                    <span class='ymq-b2b-price-hidden' ymq-b2b-product-id='${product.id}' ymq-b2b-product-handle='${productHandle}' ymq-b2b-variant-price ymq-b2b-variant-id='${product.variants[0].id}'></span>
                                </span>
                            </div>
                        `;
                        
                        const newYmqElement = $(html);
                        upsellYmqContainer.append(newYmqElement);
                    }
                    //inserção de preços
                    const discount = await hasDiscount(product.id);
                    currency ? '' : currency = discount.currency; 

                    //Verificando se o produto tem desconto ou não
                    //Se não tiver desconto, não aplicamos o preço com desconto, apenas o preço normal
                    //Se tiver desconto, aplicamos o preço com desconto e o preço normal
                    if(!discount?.percentage){
                        await appendYMQToUpsell(contentContainer, discount);
                    
                        const price = Number($(contentContainer).find('[data-essential-upsell-element="regular-price"] .ymq-b2b-current-product-price').text().replace(discount.currency, "").replace(/\./g, "").replace(",", "."));
                        const newUpsellPrice = {
                            id: product.id,
                            container: contentContainer,
                            price,
                            checked: true
                        }
                        newUpsellPrices.push(newUpsellPrice)
                        forIndex++;
                        continue;
                    }
    
                    await appendYMQToUpsell(contentContainer, discount);
                    
                    listenToSelect(contentContainer, upsellApp, discount, newUpsellPrices, product, contentContainers);
                    listenToCheckbox(contentContainer, upsellApp, discount, newUpsellPrices, product, contentContainers);
                    
                    const price = Number($(contentContainer).find('[data-essential-upsell-element="regular-price"] .ymq-b2b-current-product-price').text().replace(discount.currency, "").replace(/\./g, "").replace(",", "."));
                    const newUpsellPrice = {
                        id: product.id,
                        container: contentContainer,
                        product,
                        price,
                        checked: true
                    }

                    newUpsellPrices.push(newUpsellPrice)
                    forIndex++;
                }
                //Fim do loop
                //Mudar preço total
                await claimPrice(contentContainers, newUpsellPrices, currency, upsellApp); 
            }
        }, true, { add:true });
    }

    //Função que escuta o checkbox do container, para aplicar o desconto no upsell
    async function listenToCheckbox(container, upsellApp, discount, newUpsellPrices, product, containers){
        if(!upsellApp) return;
        try{
            const checkbox = $(container).find('input[type="checkbox"]');
            
            checkbox.on('change', async ()=>{
                try{
                    const newUpsellPrice = newUpsellPrices.find(newUpsellPrice => newUpsellPrice.id === product.id);
                    newUpsellPrice.checked = !newUpsellPrice.checked;
                    
                    await hidePrice(upsellApp, 'discounted-price', 'hidden');
                    await appendYMQToUpsell(container, discount);
                    for(const newUpsellPrice of newUpsellPrices){
                        if(newUpsellPrice.id == product.id){
                            newUpsellPrice.price = Number($(container).find('[data-essential-upsell-element="regular-price"] .ymq-b2b-current-product-price').text().replace(discount.currency, "").replace(/\./g, "").replace(",", "."));
                        }
                    }
                    const utils = new Utils();
                    await utils.delay(200);
                    await claimPrice(containers, newUpsellPrices, discount.currency, upsellApp);   
                } catch(error){
                    console.error('Erro em listenToCheckbox:', error);
                    await hidePrice(upsellApp, 'discounted-price', 'hidden');
                }
            });
        } catch(error){
            console.error('Erro em listenToCheckbox:', error);
            await hidePrice(upsellApp, 'discounted-price', 'hidden');
        }
    }

    //Função que escuta o select, para aplicar o desconto no upsell
    function listenToSelect(container, upsellApp, discount, newUpsellPrices, product, containers){
        const select = $(container).find('select');
        select.on('change', async ()=>{
            await hidePrice(upsellApp, 'discounted-price', 'hidden');
            await appendYMQToUpsell(container, discount);
            for(const newUpsellPrice of newUpsellPrices){
                if(newUpsellPrice.id == product.id){
                    newUpsellPrice.price = Number($(container).find('[data-essential-upsell-element="regular-price"] .ymq-b2b-current-product-price').text().replace(discount.currency, "").replace(/\./g, "").replace(",", "."));
                }
            }
            const utils = new Utils();
            await utils.delay(200);
            await claimPrice(containers, newUpsellPrices, discount.currency, upsellApp);
        });
    }

    //Função que aplica o preço do upsell no claim price
    //Ele pega o preço do produto e soma com os preços dos upsells selecionados e anteriormente salvos na lista de produtos (newUpsellPrices)
    //Não é aplicado caso se tenha qualquer erro nesse processo
    async function claimPrice(containers, newUpsellPrices, currency, upsellApp) {
        if(containers.find('[data-essential-upsell-element="regular-price"]').length === newUpsellPrices.length){
            try{
                const productId = $('#product-metacamp').data('product-id');

                const discount = await hasDiscount(productId);
                const variantPrices = $('#product-metacamp').data('variant-prices');
                const variantPricesArray = variantPrices.split(',').map(Number);

                const productPrice = !discount?.percentage
                    ? Number(variantPricesArray[0]) / 100 // Sem desconto
                    : (Number(variantPricesArray[0]) / 100) * discount.percentage; // Com desconto

                const sum = newUpsellPrices.reduce((acc, newUpsellPrice) => {
                    if(newUpsellPrice.checked)
                        return acc + newUpsellPrice.price;
                    return acc;
                }, 0);

                //Versão antiga caso precisemos utilizar a função firstProduct na lógica principal
                // const sum = newUpsellPrices.reduce((acc, newUpsellPrice) => {
                //     console.log('acc', acc)
                //     console.log('currentValue', newUpsellPrice.price)
                //     console.log('checked?', newUpsellPrice)
                //     if(newUpsellPrice.checked)
                //         return acc + newUpsellPrice.price;
                //     return acc;
                // }, 0) + productPrice;

                const strValue = sum.toFixed(2).replace('.',',');
                const valueArray = strValue.split(',');
                const newStrValue = valueArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ',' + valueArray[1];
                const strPrice = currency + ' ' + newStrValue;

                upsellApp.find(`[data-essential-upsell-element="discounted-price"] span`).text(strPrice);

                await showPrice(upsellApp, 'discounted-price', 'hidden');
            } catch(error){
                console.error('Erro em claimPrice:', error);
                await hidePrice(upsellApp, 'discounted-price', 'hidden');
            }
        }
    }

    //Função que aplica o preço com desconto do YMQ no container do Upsell - chamada a cada produto
    async function appendYMQToUpsell(container, discount = {percentage, currency: 'R$'}){
        const priceElement = $(container).find('[data-essential-upsell-element="regular-price"]');
        const glcMoney = priceElement.find('.glc-money');
        
        if(glcMoney.text().length == 0) return; //Verificando se o elemento existe
        
        const priceValue = Number(glcMoney.text().replace(discount.currency, "").replace(/\./g, "").replace(",", "."));
        glcMoney.text('');
        const strPrice = discount.currency + ' ' + priceValue.toString().replace('.',',');

        if(!discount?.percentage){
            const html = $(`<div class="price__regular" style="">
                <span class="ymq-b2b-current-product-price new__price-margin"><b>${strPrice}</b></span>
                </div>`);
            $(priceElement).append(html);
            
            await showPrice(container)
            return;
        }

        const newPrice = (priceValue * discount.percentage).toFixed(2);
        const strNewPrice = discount.currency + ' ' + newPrice.toString().replace('.',',');
        
        const html = $(`<div class="price__regular" style="">
                        <del class="ymq-b2b-cp-compare-price">
                        <span>${strPrice}</span>
                        </del><br class="price-space">
                        <span class="ymq-b2b-current-product-price new__price-margin"><b>${strNewPrice}</b></span>
                        </div>`);
        $(priceElement).append(html);
        
        await showPrice(container)
    }

    //Função que pega o produto com base no handle, retornando o objeto do produto
    //Ele faz a requisição para o endpoint do ShopifyAJAX API e retorna o produto
    //Caso não encontre o produto, retorna null
    //AJAX API é a única que poodemos utilizar no frontend sem um proxy app ou semelhante
    async function getProduct(productHandle){
        return await fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
            .then(response => {
                if(!response.ok){
                    throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(product => {
                return product;
            })
            .catch(error => {
                console.error('Erro em getProduct:', error);
                return null;
            });
    }

    //Document.ready() -> começa aqui
    const customer = $('#header-icon');
    if(customer.length === 0){
        // alert('NÃO LOGADO')
        return;
    }
    
    
    //App Upsell e json de produtos
    const upsell = $('essential-upsell-frequently-bought-together-app-block');
    const productsJson = JSON.parse(upsell.attr('upsell-app-data'));
    const frequentlyBoughtProducts = productsJson.funnels.find(obj => obj.content.offerType == "FREQUENTLY_BOUGHT_TOGETHER").upsell.specificProducts;
    const upsellApp = $('essential-upsell-frequently-bought-together-app-block');

    if( upsellApp.children().length > 0){
        upsellApp.addClass('hidden');
        
        const utils = new Utils();
        await utils.delay(100);

        loadUpsellPrices(upsellApp, frequentlyBoughtProducts);
        return;
    }
    console.log('Não tem Upsell')
});